

import { useMediaQuery } from '@mui/material';
import * as React from 'react'
import { createContext } from "react";


export interface IDarkMode {
  isDark: boolean,
  setDark: (dark: boolean) => void
}

export const DarkModeContext = createContext<IDarkMode>({
  isDark: false,
  setDark: () => undefined
});


function shouldSetDark(systemPrefersDark: boolean): boolean {
  if (!window?.localStorage) {
    return systemPrefersDark;
  }
  const darkMode = window.localStorage.getItem("darkMode");
  if (darkMode === 'true') {
    return true;
  } else if (darkMode === 'false') {
    return false;
  }
  return systemPrefersDark;
}

function writeCurrentDarkMode(dark: boolean) {
  if (!window?.localStorage) {
    return;
  }
  if (dark) {
    window.localStorage.setItem('darkMode', "true");
  } else {
    window.localStorage.setItem('darkMode', "false");
  }
}


type Props = {
  children: any
}

const DarkModeProvider = ({ children }: Props) => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const [dark, setDark] = React.useState<boolean>(prefersDarkMode);

  React.useEffect(() => {
    const shouldBeDark = shouldSetDark(prefersDarkMode);
    setDark(shouldBeDark);
  }, [prefersDarkMode]);

  const data = {
    isDark: dark,
    setDark: (darkEnabled: boolean) => {
      setDark(darkEnabled);
      writeCurrentDarkMode(darkEnabled);
    }
  };
  return (
    <DarkModeContext.Provider value={data}>
      <div className={`${dark ? 'dark' : ''}`}>
        {children}
      </div>
    </DarkModeContext.Provider>
  );
};

export default DarkModeProvider;


export function useDarkMode() {
  return React.useContext(DarkModeContext);
}